import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { useAuth } from "../context/AuthContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AuthCallback() {
  const hasProcessed = useRef(false);
  const navigate = useNavigate();
  const { setUser } = useAuth();

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const sessionId = new URLSearchParams(window.location.hash.replace(/^#/, "")).get("session_id");
    (async () => {
      try {
        const { data } = await axios.post(`${API}/auth/google/session`, { session_id: sessionId }, { withCredentials: true });
        setUser(data);
      } catch {
        setUser(false);
        toast.error("Google sign-in failed. Please try again.");
      }
      window.history.replaceState(null, "", "/portal");
      navigate("/portal", { replace: true });
    })();
  }, [navigate, setUser]);

  return (
    <main className="pt-24 min-h-screen flex items-center justify-center" data-testid="auth-callback-page">
      <Loader2 className="h-8 w-8 animate-spin text-blue-500" />
    </main>
  );
}
